export const isNewContact = (contactID: string) => {
  return contactID.indexOf('new-') === 0
}
